const topics = [
  { tag: '#韩漫推荐', count: '2.8万讨论', hot: true },
  { tag: '#下拉式阅读', count: '1.6万讨论', hot: true },
  { tag: '#免费全集', count: '3.2万讨论', hot: true },
  { tag: '#恋爱甜漫', count: '2.1万讨论', hot: false },
  { tag: '#我独自升级', count: '1.9万讨论', hot: true },
  { tag: '#手机看漫画', count: '8.5千讨论', hot: false },
  { tag: '#社内相亲', count: '1.4万讨论', hot: false },
  { tag: '#日漫连载', count: '2.3万讨论', hot: true },
  { tag: '#穿越题材', count: '1.1万讨论', hot: false },
  { tag: '#女神漫画网', count: '4.6万讨论', hot: true },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[1400px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900">热门话题</h2>
          <p className="text-sm text-foreground-500 mt-2">女神漫画下拉式社区热议话题，加入讨论</p>
        </div>

        <div className="flex flex-wrap gap-3 justify-center">
          {topics.map((topic, i) => (
            <div
              key={i}
              className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border cursor-pointer transition-all duration-200 hover:scale-105 ${
                topic.hot
                  ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                  : 'bg-background-100 border-background-200 text-foreground-600 hover:bg-background-200'
              }`}
            >
              {topic.hot && <i className="ri-fire-line text-accent-500 text-sm"></i>}
              <span className="text-sm font-medium whitespace-nowrap">{topic.tag}</span>
              <span className={`text-xs whitespace-nowrap ${topic.hot ? 'text-primary-400' : 'text-foreground-400'}`}>
                {topic.count}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}